module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/logos/developer/bootstrap-04d43c44c0b93032c1eb0162594263cc.svg";